import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-4",
  "use": "menu-4-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"menu-4\"><title>menu-4</title><path d=\"M19.93,5.1\" fill=\"#242424\" /><path d=\"M3.64.91A1,1,0,0,0,2.73,0a1,1,0,0,0-.91.91V4.55H0V10H5.45V4.55H3.63V.91ZM7.27,13.64a2.65,2.65,0,0,0,1.82,2.54V20h1.82V16.18a2.65,2.65,0,0,0,1.82-2.54V11.82H7.27ZM0,13.64a2.65,2.65,0,0,0,1.82,2.54V20H3.64V16.18a2.65,2.65,0,0,0,1.82-2.54V11.82H0Zm14.54,0a2.65,2.65,0,0,0,1.82,2.54V20h1.82V16.18A2.65,2.65,0,0,0,20,13.64V11.82H14.54Zm3.64-9.09V.91a.91.91,0,1,0-1.82,0V4.55H14.54V10H20V4.55ZM10.91.91A1,1,0,0,0,10,0a1,1,0,0,0-.91.91V4.55H7.27V10h5.45V4.55H10.91Zm0,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-4.svg
// module id = 4DPq
// module chunks = 264